import React from 'react'
import Duration from './Duration'
import { useNow } from './hooks'

export type Props = {
    target: string | number
}

export default function TimeRemaining({ target }: Props) {
    const t = typeof target === 'string' ? new Date(target).getTime() : target
    const now = useNow()
    return <Duration ms={t - now} />
}
